/*
 * Project: BookingEngine
 * Module: components/icons/CheckFillIcon.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';

const CheckFillIcon = () => (
  <svg className="svg-icon check-fill-icon" width="21px" height="20px" viewBox="10 10 21 20" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g transform="translate(0.000000, 0.000000)">
      <circle className="check-circle" fillRule="evenodd" cx="20" cy="20" r="10" />
      <polygon className="check-tick" fillRule="evenodd" points="13 17 17 17 19 20 27 11 31 11 19 25" />
    </g>
  </svg>
);

export default CheckFillIcon;
